<template>
    <v-card class="overflow-hidden v-card v-sheet theme--light mt-0">
      <!-- Alert message -->
      <div>
        <v-alert :type="alert_type" :model-value="alert" class="text-left" :value="alert" transition="scale-transition">{{ alert_message }}</v-alert>
      </div>
      <!-- main content -->
      <!-- Header Component -->
      <div> <HeaderComponent :headerTitle="headerText" /></div>
       <v-snackbar
          v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :location="snackbar.position === 'top' ? 'top' : 'bottom'">
          <v-layout align-center pr-4>
            <v-icon class="pr-3 ml-2" dark large>{{ snackbar.icon }}</v-icon>
            <v-layout column>
              <div>{{ snackbar.text }}</div>
            </v-layout>
          </v-layout>
          <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-snackbar>
      <!-- Approve confirm popup -->
        <v-row justify="center">
          <v-dialog v-model="approveconfirmpopup" persistent max-width="424px">
            <v-card class="v-card-100">
                <v-card-title class="d-flex">
                  <v-spacer></v-spacer>
                  <v-btn variant="solo" icon @click="approveconfirmpopup = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider :thickness="4" class="border-opacity-25 m-0"/>
                <v-card-text class="text-center" >
                  <span> Are you sure you want to Approve?</span>
                </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="adminApproveItem">Yes</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- reject conform popup -->
        <v-row justify="center">
            <v-dialog v-model="rejectconfirmpopup" persistent max-width="424px">
              <v-card class="v-card-100">
                  <v-card-title class="d-flex">
                    <v-spacer></v-spacer>
                    <v-btn variant="solo" icon @click="rejectconfirmpopup = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider :thickness="4" class="border-opacity-25 m-0"/>
                  <v-card-text class="text-center" >
                    <span> Are you sure you want to Reject?</span>
                  </v-card-text>
                <v-card-actions center>
                  <v-spacer></v-spacer>
                  <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="adminRejectItem">Yes</v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        <!--  Success messeage popup -->
        <v-row justify="center">
          <v-dialog v-model="successpopup" persistent max-width="424px">
            <v-card class="v-card-100">
              <v-card-title class="d-flex">
                <v-spacer></v-spacer>
                <v-btn variant="solo" icon @click="successpopup = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider :thickness="4" class="border-opacity-25 m-0"/>
              <v-card-text class="text-center">
                <span> {{ successmessage }}</span>
              </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn variant="flat" color="primary" class="mb-3 text-none" @click="afterClickOkLoadData">Ok</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- delete lot -->
        <v-row justify="center">
          <v-dialog v-model="deletelotDilog" persistent max-width="450px">
            <v-card class="v-card-100">
              <v-card-title>
                <span>Confirmation</span><br>                 
              </v-card-title>
              <v-divider :thickness="4" class="border-opacity-25 m-0"/>
              <v-card-text>
                <v-container>
                  <v-row>
                  <span>  Are you sure want delete the lot? </span><br>  
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions style="justify-content: center;">
                <v-btn variant="outlined" small class="text-none" text color="normal" @click="deletelotDilog = false">Cancel</v-btn>
                <v-btn variant="flat" small class="text-none" color="primary" @click="deletelotconfirm">Confirm</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Search invoice items popup -->
        <v-row justify="center">
          <v-dialog v-model="invoiceItemPopup" persistent fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card class="v-card-100 m-0">
              <v-toolbar dark color="primary">
                <v-toolbar-title class="alert-link">Selected {{ req_id }} items</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-card-actions>
                  <v-btn variant="flat" class="text-none" :color="this.edit_assign_selected.length == 0 ? 'primary' : 'white'" :disabled="(this.edit_assign_selected.length == 0)" small  @click="openAssignSpStPopup">Assign Executive</v-btn>
                  <!-- <v-btn class="blue--text" color="white" small  >ADD MORE ITEMS</v-btn> -->
                  <!-- <v-btn class="blue--text" color="white" small  >DELETE ALL</v-btn> -->
                  <v-btn variant="solo" color="secondary" icon dark @click="invoiceItemPopup = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-actions>
              </v-toolbar>
              <v-layout row>
                <v-data-table 
                  :dense="true" 
                  show-select
                  v-model="edit_assign_selected"
                  :headers="edit_req_headers"
                  :items="edit_req_table_data"
                  disable-pagination
                  :hide-default-footer="true"
                  :loading="loading" loading-text="Loading Data... Please wait"
                  class="elevation-1" style="overflow:scroll;">

                  <template #[`item.creation_date`]="{ item }" >
                    {{ item.creation_date }}
                  </template>
                  <!-- <template v-slot:item.delete="{ item }">
                    <a href="javascript:void(0)" class="icon">
                      <i v-on:click="updateReturnCreation(item)" class="fas fa-trash-alt" style="font-size:medium;color:#EC0101;"></i>
                    </a>
                  </template> -->
                  <template #bottom></template>
                </v-data-table>
              </v-layout>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Assign SP/ST popup -->
        <v-row justify="center">
          <v-dialog v-model="assignSpStPopup" persistent max-width="366px">
            <v-card class="v-card-100">
              <v-card-title>
                <v-row class="ma-1">
                <span>Assign SP/ST</span>
                <v-spacer></v-spacer>
                <!-- <v-btn @click="closeAssignSpStPopup" style="float:right; "> -->
                  <v-icon @click="closeAssignSpStPopup" >mdi-close</v-icon>
                <!-- </v-btn> -->
              </v-row>
              </v-card-title>
              <v-divider :thickness="4" class="border-opacity-25 m-0"/>
              <v-card-text>
                <v-container>
                  <v-col cols="6" sm="12" md="12" style="height: 96px;">
                    <v-combobox v-model="assign_to" :items="assign_to_items_list" style="margin-bottom: -30px;" prepend-inner-icon="mdi-magnify" variant="outlined" item-title="username" item-value="id" 
                    label="Assign To" v-on:keyup.enter="openAssignSpStPopup" class="ma-2" required> </v-combobox>
                  </v-col>
                </v-container>
              </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn size="small" variant="outlined" color="primary" class="mb-3 text-none" @click="closeAssignSpStPopup" :disabled="!assign_to">Cancel</v-btn>
                <v-btn size="small" variant="flat" color="primary" class="mb-3 text-none" :disabled="!assign_to" @click="createServiceRequest">Submit</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- data detail popup  -->
         <v-row justify="center">
          <v-dialog v-model="datadetailpopupdisposition" persistent max-width="700px">
            <v-card class="v-card-100">
                <v-card-title class="d-flex">
                  <span>Request ID "{{ return_request_id }}"</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="datadetailpopupdisposition = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider :thickness="4" class="border-opacity-25 m-0"/>
                <v-card-text>
                  <v-container>
                    <div>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <span style="font-weight: 500;">Return Request ID</span>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          {{ return_request_id }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <span style="font-weight: 500;">Return Request Sub-ID</span>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          {{ return_sub_request_id }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6" sm="6" md="6">
                          <span style="font-weight: 500;">Request Type</span>
                        </v-col>
                        <v-col cols="6" sm="6" md="6">
                          {{ request_type }}
                        </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="6" sm="6" md="6">
                            <span style="font-weight: 500;">Creation Date</span>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            {{ creation_date }}
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" sm="6" md="6">
                            <span style="font-weight: 500;">Status</span>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            {{ status }}
                          </v-col>
                        </v-row>
                    </div>
                  </v-container>
                </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Update Status popup -->
        <v-row justify="center">
          <v-dialog v-model="updateStatusPopup" persistent max-width="366px">
            <v-card class="v-card-100">
              <v-card>
                <v-card-title>
                  <span>Update Status</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="updateStatusPopup = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
              <v-card-text>
                <v-container>
                  <v-col cols="6" sm="12" md="12" style="height: 96px;">
                    <v-combobox 
                        v-model="change_status"
                        :items="change_status_items"
                        item-title="status"
                        item-value="status"
                        :item-disabled="disabled" 
                        style="margin-bottom: -30px;" 
                        prepend-inner-icon="mdi-magnify" 
                        outlined label="Change Status" 
                        class="ma-2"> </v-combobox>
                  </v-col>
                </v-container>
              </v-card-text>
              <v-card-actions center>
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-3 text-none" variant="outlined" @click="updateStatusPopup = false" :disabled="!assign_to">Cancel</v-btn>
                <v-btn color="primary" class="mb-3 text-none" variant="flat" :disabled="!change_status" @click="submitUpdateStatus">Submit</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <!-- Image show popup -->
        <v-dialog v-model="dialogVisible" persistent max-width="600">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-row class="ma-2">
              <span class="headline">Images</span>
              <v-spacer></v-spacer>
              <!-- <v-btn icon variant="solo" @click="closeDialog"> -->
                <v-icon  @click="closeDialog">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
            
            <v-card-text>
              <v-row>
                <v-col v-for="(imageUrl, index) in item_images" :key="index" cols="4">
                  <img :src="imageUrl" width="100%" contain @click="openImagePopupSingle(imageUrl)" class="img-rad-size" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog v-model="approvalHistoryPopup" persistent max-width="1100">
        <v-card class="v-card-100">
          <v-card-title class="d-flex align-center">
            <span class="headline">Approval History</span>
            <v-spacer></v-spacer>
            <v-btn icon variant="solo" @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          
          <v-card-text>
            <v-data-table
              density="compact"
              :dense="true"
              v-model="approvalHistory"
              :items="history_table_data"
              disable-pagination
              :hide-default-footer="false"
              :headers="Historyheaders"
              :loading="loading"
              fixed-header
              loading-text="Loading Data... Please wait"
              class="elevation-1 overflow-auto"
            >
            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatTimestamp(item.created_at) }}
            </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions center>
            <v-spacer></v-spacer>
            <v-btn color="primary"  variant="flat" class="mb-3 text-none" @click="closeDialog">Okay</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <v-dialog v-model="imagePopup" persistent max-width="600">
          <v-card class="v-card-100">
            <v-card-title class="d-flex">
              <v-row class="ma-1">
              <v-spacer></v-spacer>
              <!-- <v-btn color="primary" style="float:right;" @click="imagePopup = false;"> -->
                <v-icon color="primary" style="float:right;" @click="imagePopup = false;">mdi-close</v-icon>
              <!-- </v-btn> -->
            </v-row>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <v-img :src="selectedImage" width="100%" style="border-radius:8px;" contain></v-img>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Edit Serial number popup -->
        <v-row justify="center">
          <v-dialog v-model="editSerialPopup" persistent max-width="600px">
            <v-card class="v-card-100 mt-0">
              <v-card class="v-card-100 mt-0 custom-shadow">
                <v-card-title class="pa-0">              
                <v-row class="ma-1">
                  <span class="font-weight-bold pl-2 pr-2">Edit</span>
                  <v-spacer></v-spacer>
                    <v-icon @click="editSerialPopup = false">mdi-close</v-icon>
                </v-row>              
               </v-card-title>
              </v-card>
              <v-card-text>
              <v-row class="pt-2">
              <v-col cols="6">
                <v-text-field v-model="serial_number_1" label="Serial No. 1" variant="outlined" hide-details></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="serial_number_2" label="Serial No. 2" variant="outlined" hide-details></v-text-field>
              </v-col>
              </v-row>
              <v-row>
               <v-col cols="6">
                <v-file-input
                  v-model="serial_number_file"
                  accept=".pdf"
                  @update:modelValue="handleImageUpload"
                  class=""
                  variant="outlined"
                  prepend-inner-icon="mdi-paperclip"
                  prepend-icon=""
                  label="Attach Document"
                  :error="fileError" 
                  :error-messages="fileErrorMessage"
                >
                </v-file-input>
               </v-col>
              </v-row>
              </v-card-text>
              <v-card-actions center style="margin-top: -30px;">
                <v-spacer></v-spacer>
                <v-btn color="primary" class="mb-3 text-none" variant="outlined" @click="editSerialPopup = false">Cancel</v-btn>
                <v-btn color="primary" class="mb-3 text-none" variant="flat" @click="submitEditSerialNo" :disabled="!serial_number_1 || !serial_number_file">Submit</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      <!-- filter data popup -->
      <v-row justify="center">
        <v-dialog content-class="filter-insurance" v-model="filteWithSubPopup" persistent :max-width="filter_width">
          <v-card  class="filter_ui">
            <v-card-actions>
                <v-text-field prepend-inner-icon="mdi-magnify"  v-model="crm_ticket_number" label="Client CRM Ticket Number"  class="ma-2" variant="outlined"></v-text-field>
                <v-text-field prepend-inner-icon="mdi-magnify"  v-model="request_sub_id" label="Return Request Sub-ID"  class="ma-2" variant="outlined"></v-text-field>
                <v-text-field prepend-inner-icon="mdi-magnify"  v-model="tag_id" label="Tag ID"  class="ma-2" variant="outlined"></v-text-field>
                <v-autocomplete v-model="request_type" :items="request_type_items" item-title="" item-value="" label="Request Type" multiple variant="outlined" class="ma-2"> </v-autocomplete>
                <v-autocomplete v-model="status" :items="status_items" item-title="" item-value="" label="Status" multiple variant="outlined" class="ma-2"> </v-autocomplete>
                <v-autocomplete v-model="branch" :items="branch_items" item-title="" item-value="" label="Branch" multiple variant="outlined" class="ma-2"> </v-autocomplete>
            </v-card-actions>
            <v-card-actions class="margin-10">
              <v-spacer></v-spacer>
              <v-btn size="small" class="text-none" variant="outlined" color="primary" @click="closeFilterpopup">Cancel</v-btn>
              <v-btn size="small" class="text-none" variant="flat" color="primary" @click="applyFilterFunc" :disabled="number > 0">Apply Filter(S)</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
      <!-- Action and search -->
      <v-card-title style="padding: 25px 25px 15px 15px;" class="action-style mt-6">
        <!-- search -->
        <v-row>
          <v-col cols="3" sm="3" class="pb-0">
            <v-text-field prepend-inner-icon="mdi-magnify" v-model="return_search" label="Search" style="max-width: 300px;" variant="outlined" @keyup.enter="loadData"></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
        <!-- Actions buttons -->
        <v-card-actions style="display: flex; margin-bottom: 10px !important;">
          <v-menu offset-y>
               <template v-slot:activator="{ props }">
                  <v-btn color="primary" variant="flat" v-bind="props" class="text-none ma-0 px-5" size="x-large">
                    Select Action
                    <v-icon class="ml-1">mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in actionList" :key="index" :disabled="isActionDisabled(item)">
                    <v-list-item-title style="cursor: pointer;" @click="updateAction(item)">{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
        </v-card-actions>
        <!-- Filter -->
        <v-expansion-panels class="custom-control_outlined m-0 pt-3" ref = "filterPopupRef" readonly style="max-width: 110px; margin-bottom: 16px; height: 52px;">
          <v-expansion-panel variant="outlined" @click="filterListOfButtons" >
            <v-expansion-panel-title>Filter
            </v-expansion-panel-title>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
      </v-card-title>
      <v-layout column>
        <!-- <v-flex md6 style="overflow: auto"> -->
          <v-data-table 
            density="compact"
            :search="search"
            v-model="selected"
            show-select
            disable-pagination
            :hide-default-footer="true"
            :headers="headers"
            :items="table_data"
            fixed-header
            height="100%"
            :loading="loading"
            :items-per-page="pageSize"
            loading-text="Loading Data... Please wait"
            class="elevation-1"
            return-object
            :dense="true"
          >
            <template v-slot:[`item.${header.key}`]="{ item }" v-for="header in headers" :key="header.key">
              <span v-if="header.key == 'sub_request_id'">
                <a href="#" @click.prevent="returnRequestDetailPopup(item, 'Sub Request ID')" style="text-decoration: underline !important; color: #1976d2 !important; cursor: pointer !important;">{{ item.sub_request_id }}</a>
              </span> 
              <span v-else-if="header.key == 'crm_ticket_number'">
                {{ item.crm_ticket_number ? item.crm_ticket_number : '-'}}
                <v-icon color="error" style="font-size:10px" v-if="item.is_repropose_to_asm === true && currentUser.roles[0] === 'area_service_manager'"> mdi-circle</v-icon>
              </span> 
              <span v-else-if="header.key == 'sub_request_status'">
                {{ item.sub_request_status ? item.sub_request_status : '-'}}
              </span>
              <span v-else-if="header.key !== 'images' && item[header.key]">
                <span v-tooltip="item[header.key]">
                  {{ item[header.key].length > 20 ? item[header.key].slice(0, 20) + '...' : item[header.key] }}
                </span>
              </span>
              <span v-else-if="header.key === 'images' && item.images && item.images.length > 0">
                <a @click.prevent="viewCustomerDeclarationImages(item)" style="text-decoration: underline; color:#1976d2; cursor: pointer;">
                  View
                </a>
              </span>
              <span v-else-if="header.key === 'approval_history' && item.has_approval_history === true && !item.update">
                <a @click="viewApprovalHistory(item)">
                  <span style="text-decoration: underline; color:#1976d2; cursor: pointer;">View</span>
                </a>
              </span>
              <span v-else-if="header.key === 'update'">
                <v-btn class="ma-2 text-none" 
                  v-if="organization_name === 'Voltas' || organization_name === 'Crompton' || organization_name === 'Blubirch'" 
                  color="primary" 
                  style="color: #FFFFFF;" 
                  :disabled="item.sub_request_status == 'Closed - Approved' || item.sub_request_status == 'Closed - Reject' || item.sub_request_status == 'In Process - Reject'" 
                  variant="outlined" 
                  @click="updateReturnCreation(item)">
                  Update
                </v-btn>
                <v-btn class="ma-2 text-none" 
                  v-else 
                  plain 
                  style="border:0px" 
                  :disabled="item.sub_request_status == 'Closed - Approved' || item.sub_request_status == 'Closed - Reject' || item.sub_request_status == 'In Process - Reject'" 
                  @click="updateReturnCreation(item)">
                  <v-icon color="primary">mdi-pencil-outline</v-icon>
                </v-btn>
              </span>
              
              <span v-else>-</span>
            </template>

            <!-- <template #[`item.crm_ticket_number`]="{ item }" >
              {{ item.crm_ticket_number  ? item.crm_ticket_number : '-'}}
            </template>
            <template #[`item.creation_date`]="{ item }">
              {{ item.creation_date }}
            </template>
            
            <template #[`item.customer`]="{ item }" >
              {{ item.customer ? item.customer : 'N/A' }}
            </template>
            <template #[`item.location`]="{ item }" >
              {{ item.location ? item.location : item.branch ? item.branch : '-' }}
            </template> -->
            <!-- <template #[`item.images`]="{ item }">
              <a @click="viewCustomerDeclarationImages(item)" v-if="item.images != ''">
                <span style="text-decoration: underline;color:#1976d2; cursor: pointer;">View</span>
              </a>
              <span v-else>-</span>
            </template> -->
            <!-- <template #[`item.update`]="{ item }">
              <v-btn class="ma-2 text-none" v-if="organization_name === 'Voltas'" color="primary" style="color: #FFFFFF;" :disabled="item.sub_request_status == 'Closed - Approved' || item.sub_request_status == 'Closed - Reject' || item.sub_request_status == 'In Process - Reject'" variant="outlined" @click="updateReturnCreation(item)">Update</v-btn>
              <v-btn class="ma-2 text-none" variant="outlined" v-else plain style="color: #FFFFFF; border:0px" :disabled="item.sub_request_status == 'Closed - Approved' || item.sub_request_status == 'Closed - Reject' || item.sub_request_status == 'In Process - Reject'" @click="updateReturnCreation(item)"><v-icon color="primary">mdi-pencil-outline</v-icon></v-btn>
            </template> -->
            <!-- <template #[`item.approval_history`]="{ item }">
              <a @click="viewApprovalHistory(item)" v-if="item.has_approval_history === true">
                <span style="text-decoration: underline;color:#1976d2; cursor: pointer;">View</span>
              </a>
              <span v-else>N/A</span>
            </template> -->
            
            <!-- <template v-slot:item.sub_request_status="{ item }" v-if="currentUser.roles.includes('default_user')">
              <div>
                <template v-if="item.sub_request_status === 'Closed Reject'">
                  <a @click="returnRequestDetailPopup(item, 'Status')" style="color: #1976d2;">
                    <u>{{ item.sub_request_status ? item.sub_request_status : "N/A" }}</u>
                  </a>
                </template>
                <template v-else>
                  {{ item.sub_request_status }}
                </template>
              </div>
            </template> -->
            <template #bottom></template>
          </v-data-table>
        <!-- </v-flex> -->
      </v-layout>
             <div>
                <PaginationComponent
                    :pageSize="pageSize"
                    :pageSizes="pageSizes"
                    :totalCount="totalCount"
                    :selected="selected"
                    :page="page"
                    :totalPages="totalPages"
                    @update:pageSize="handlePageSizeChange"
                    @update:page="handlePageChange"
                    class="mt-2 mb-0"
                />
            </div>
    </v-card>
  </template>
  <script>
    import HeaderComponent from '../../../commoncomponents/HeaderComponent.vue';
    import { defaultPageSize, defaultPageSizes } from '@/components/commoncomponents/PaginationComponent.vue';
    
    export default{
      data(){
        return{
          headerText: "Return Creation",
          alert_type:'success',
          alert_message:'',
          return_search:'',
          alert: false,
          selected:[],
          filteWithSubPopup:false,
          request_sub_id: '',
          crm_ticket_number: '',
          request_id:'',
          status:null,
          selected_manf: [],
          request_type_items:[],
          status_items: '',
          returnTypeList: [],
          assignSpStPopup: false,
          invoiceItemPopup: false,
          UndeliveredType: [],
          closedStatus: [],
          currentUser: {},
          headers: [
            { title: "Return test", key: "return_sub_request_id",  sortable: false },
            {title: "Return Request ID", key: "return_request_id"},
            { title: "Request Type", key: "return_type" },
            { title: "Creation Date", key: "creation_date" },
            { title: "Status", key: "status" }
          ],
          table_data: [],
          deletelotDilog: false,
          successpopup: false,
          successmessage: '',
          errorpopup: false,
          errormessage: '',
          search_type: '',
          tab_index: '',
          createRequest: '',
          assignDisposition: '',
          approveconfirmpopup: false,
          rejectconfirmpopup: false,
          datadetailpopupdisposition: false,
          loading: false,
          return_request_id: [],
          return_sub_request_id: [],
          client_crm_ticket_no: [],
          edit_req_headers: [],
          request_type: null,
          assign_to: null,
          item_details: [],
          req_id : '',
          creation_date: '',
          number: 0,
          isButtonDisabled: true,
          page : 1 ,
          totalPages : 1,
          totalCount: '',
          isFiltering: false,
          filterPage: 1,
          pageSize: defaultPageSize,
          pageSizes: defaultPageSizes,
          return_item_type: '',
          return_items_data: [],
          edit_req_table_data: [],
          assign_to_items: [],
          assign_to_items_list: [],
          edit_assign_selected: '',
          dialogVisible: false,
          item_images: [],
          imagePopup: false,
          selectedImage: '',
          branch_items:[],
          branch:null,
          organization_name:'',
          updateStatusPopup:false,
          change_status_items:[],
          change_status:'',
          approvalHistoryPopup: false,
          approvalHistory: [],
          history_table_data: [],
          Historyheaders: [],
          filter_width:'950px',
          editSerialPopup:false,
          serial_number_1:null,
          serial_number_2:null,
          serial_number_file:null,
          serial_number_file_name:[],
          fileErrorMessage:'',
          fileError: false,
          tag_id: '',
          snackbar: {
            color: null,
            icon: null,
            mode: null,
            position: "top",
            text: null,
            timeout: 7500,
            title: null,
            visible: false
          },
          actionList:[]
        }
      },
      components: {
        HeaderComponent
      },
      async created() {
        this.headerText = this.$store.state.title;
        this.currentUser = this.$store.state.currentUser;
        this.organization_name = this.$store.state.organization_name;
        this.loadData()
        this.scrollToTop();

        if(this.headerText === 'Return Creation'){
            this.actionList = ["Upload Tickets", "Create Request", "Assign SP/ST", "Edit Serial No", "Offline Upload Template", "Download"]
          }else {
            this.actionList = ["Upload", "Download"]
          }

      },
      watch: {
        selected(newVal) {
          const returnSelected = newVal.filter(
            return_creation => 
              return_creation.is_service_created === true || return_creation.restrict_service_ticket_create === true
          )

          this.undeliveredSelected = newVal.filter(
            return_creation =>
              return_creation.request_type === 'Undelivered Returns Sales Return'
          )
          this.closedStatus = newVal.filter(
            return_creation =>
              return_creation.sub_request_status === 'Closed - Approved'
          )

          const ticketNumbers = returnSelected.map(item => item.bb_ticket_no).join(', ');
          if (returnSelected.length > 0 && this.headerText === 'Return Creation') {
            this.showAlert("error", "Service is already created for this tickets: " + ticketNumbers);
          }
        },
        '$store.state.title': function (newVal) {
          this.headerText = newVal;
          if(newVal === 'Return Creation'){
            this.actionList = ["Upload Tickets", "Create Request", "Assign SP/ST", "Edit Serial No", "Offline Upload Template" , "Update Status","Download"]
          }else {
            this.actionList = ["Upload", "Download"]
          }
          this.return_search = '';
          this.closeFilterpopup();
          this.loadData();
        }
      },
      computed: {
        canDeleteItems() {
          return this.selected.length > 0 && this.selected.every(item => item.status === "Pending Eligibility Validation");
        },
        filteredReturnTypeList() {
          return this.returnTypeList.map(item => {
            if (item.original_code === 'Pullback Return') {
              return { ...item, disabled: true };
            } else {
              return item;
            }
          });
        },
      },
      methods:{
        loadData() {
          this.selected = []
          this.table_data = []
          this.page = 1
          this.isFiltering = false;
          this.totalPages = 1
          this.filterPage = 1;
          this.loading = true;
          if(this.$isWhirlpoolClient() && (this.organization_name !== 'Crompton' && this.organization_name !== 'Blubirch')){
             this.headers = [
              { title: "CRM Ticket No.", key: "crm_ticket_number", minWidth: "200px"},
              { title: "Sub Request ID", key: "sub_request_id", sortable: false, minWidth: "200px" },
              { title: "Creation Date", key: "creation_date", minWidth: "200px"},
              { title: "Customer", key: "main_dealer_name", minWidth: "200px" },
              { title: "Stage", key: "stage", minWidth: "200px" },
              { title: "Request Type", key: "request_type", minWidth: "200px" },
              { title: "Location", key: "location", minWidth: "200px" },
              { title: "Status", key: "sub_request_status", minWidth: "200px" },
              { title: "Update", key: "update", minWidth: "200px" },
            ];
          }else{
            this.headers = [
              { title: "Client CRM Ticket No.", key: "crm_ticket_number", minWidth: "200px"},
              { title: "Sub Request ID", key: "sub_request_id", sortable: false, minWidth: "200px" },
              { title: "BB Ticket No.", key: "bb_ticket_no", minWidth: "200px"},
              { title: "Creation Date/Ageing", key: "creation_date", minWidth: "200px" },
              { title: "Customer/Entity", key: "main_dealer_name", minWidth: "200px" },
              { title: "Purchase Dealer", value: "dealer_pan"},
              { title: "Stage", key: "stage", minWidth: "200px" },
              { title: "Request Type", key: "request_type", minWidth: "200px" },
              { title: "Location", key: "location", minWidth: "200px" },
              { title: "Sub-Request Status", key: "sub_request_status", minWidth: "200px" },
              {title: "Images", key: "images", minWidth: "200px"},
              { title: "Approval History", key: "approval_history",minWidth: "200px" },
            ];

            if(this.headerText === 'Return Creation'){
              this.headers.push({ title: "Update", key: "update", minWidth: "200px" });
            }
          }
          this.maindata();
          
        },
        viewApprovalHistory(item){
          this.loading = true;
          this.history_table_data = []
          this.Historyheaders = [
            { title: "Date & Time", key: "created_at"},
            { title: "Approver Name & ID", key: "approver_name", sortable: false },
            { title: "Approver Role", key: "approver_role"},
            { title: "Decision", key: "decision" },
            { title: "Remarks", key: "remarks" },
            { title: "Action", key: "status" },
          ];
          this.$httpSecured
          .get(`/api/v1/warehouse/return_initiation/return_approvals/${item.id}/approval_histories`)
          .then(response => {
            if(response.data) {
              this.history_table_data = response.data.data
              this.approvalHistoryPopup = true;
              this.loading = false;
            } else {
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        },
        maindata() {
          const params = this.getRequestParams(this.page, this.pageSize);
          let requestBody = {
            query: this.return_search,
            page: params['page'],
            per_page: params['size']
          }
            if(this.headerText === 'Request & Tickets'){
              requestBody['status'] = "Pending Approval Docs";
            }
            this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/return_creations", { params: requestBody })
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_creation;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        invoiceItemDataPopup() {
          this.req_id = this.selected.length;
          this.invoiceItemPopup = true;
          this.edit_req_headers = [
            { title: "Client CRM Ticket No.", key: "crm_ticket_number"},
            { title: "Sub Request ID", key: "sub_request_id", sortable: false },
            { title: "Creation Date/Ageing", key: "creation_date" },
            { title: "Customer/Entity", key: "customer" },
            { title: "Request Type", key: "request_type" },
            { title: "Location", key: "location" },
            { title: "Sub-Request Status", key: "sub_request_status" },
            { title: "", key: "delete" },
          ];
          this.edit_req_table_data = this.selected
        },

        viewCustomerDeclarationImages(item) {
          this.dialogVisible = true;
          this.item_images = item.images
        },
        openImagePopupSingle(image) {
          this.selectedImage = image;
          this.imagePopup = true;
        },
        closeDialog(){
          this.dialogVisible = false;
          this.approvalHistoryPopup = false;
        },
        
        // Get Return item data(show)
        returnRequestDetailPopup(item,action){
          if(action == 'Sub Request ID'){
            this.$store.commit("setRequestDetails",{
            action : action,
            items : JSON.stringify(item),
          });
          }
          if(action == 'Pull Back Invite ID'){
            this.$router.push({ name: 'PullbackReturnIdDetailsRia' });
          }else{
            this.$router.push({ name: 'ReturnRequestIdDetailsRia' });
          }
        },

        updateReturnCreation(item){
          if (item.request_type) {
            let return_item = '';
            if(item.stage === 'Request'){
              return_item = 'return_item'
            }else if(item.stage === 'Ticket'){
              return_item = 'return_item_ticket'
            }
            const requestBody = {
              return_item_type: return_item,
            }
            this.$httpSecured
            .get(`/api/v1/warehouse/return_initiation/return_creations/${item.id}`, { params: requestBody })
            .then(response => {
              if (response.data) {
                this.$store.commit("setLotIds", {});
                this.$store.commit("setRequestDetails",{
                  actionRequest: 'requested',
                  items : JSON.stringify(response.data.return_item),

                });
                this.$router.push({ name: "ReturnCreationRequestRia"});
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
            
          }
        },
        
        disableItem(item) {
          return item.original_code === 'Pullback Return';
        },

        approveConfirmPopup() {
          this.approveconfirmpopup = true;
        },
        openAssignSpStPopup() {
          if(this.edit_assign_selected.length === 0){
            this.$toast.error("Please Select Data");
          }else{

            this.assignSpStPopup = true;
            const requestBody = {
              query: this.assign_to,
            }
            this.$httpSecured
            .get("/api/v1/warehouse/return_initiation/return_creations/service_partners?", { params: requestBody })
            .then(response => {
              if (response.data) {
                this.assign_to_items_list = response.data.users;
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
          }
        },

        // Create Service Request(post) {
        createServiceRequest() {
          let skip_ticket;
          this.edit_assign_selected.map(item => {
            if(item.is_crm_outbounded === true){
              skip_ticket = true
            }else {
              skip_ticket = false
            }
          })
          const crm_numbers = this.edit_assign_selected.map(item => item.crm_ticket_number).join(',');
          
          const requestData = {
            user_id: this.assign_to.id,
            crm_ticket_numbers: crm_numbers,
            skip_ticket: skip_ticket,
            ids: this.selected.map(item => item.id)
          }
          this.$httpSecured
          .post("/api/v1/warehouse/return_initiation/return_creations/create_service_request", requestData)
          .then((response) => {
            if (response.data) {
              this.edit_assign_selected = [];
              this.selected = [];
              this.successpopup = true;
              this.successmessage = "Service Request Created Successfully";
              setTimeout(() => {
                this.assignSpStPopup = false;
                this.invoiceItemPopup = false;
              }, 3000);
            } else {
              this.showAlert("error", "No Data Found");
            }
          })
          .catch((error) => {
            this.$toast.error(error.response.data.error);
            this.loading = false;
            this.edit_assign_selected = [];
            this.selected = [];
            this.assignSpStPopup = false;
          });
        },

        closeAssignSpStPopup() {
          this.assign_to = '';
          this.assignSpStPopup = false;
          this.select_method = ''
        },
        adminApproveItem() {
          this.return_id = this.selected.map(return_items => return_items.id);
          const formData = new FormData();
          formData.append('return_ids', this.return_id)
          this.$httpSecured
            .post(`/api/v1/warehouse/return_initiation/return_eligibility_validations/approve`, formData)
            .then((response) => {
  
              if (response.data) {
                this.approveconfirmpopup = false
                this.successpopup = true;
                this.successmessage = response.data.message;
                this.loadData();
              } else {
                this.showAlert("error", "No Data Found");
              }
            })
          .catch((error) => {
            console.error("API Error:", error);
            if (error.response) {
              this.showAlert("error", error.response.data.error);
            } else {
              this.showAlert("error", "An unexpected error occurred.");
            }
            this.loading = false;
          });
        },
        adminrejectpopup() {
        this.rejectconfirmpopup = true;
        },
        adminRejectItem() {
          this.return_id = this.selected.map(return_items => return_items.id);
          const formData = new FormData();
          formData.append('return_ids', this.return_id)
          this.$httpSecured
            .post(`/api/v1/warehouse/return_initiation/return_eligibility_validations/reject`, formData)
            .then((response) => {
              if (response.data) {
                this.successpopup = true
                this.successmessage = response.data.message;
                this.rejectconfirmpopup = false;
                this.loadData();
              } else {
                this.showAlert("error", "No Data Found");
              }
            })
          .catch((error) => {
            this.showAlert("error", error.response.data.error);
            this.loading = false;
          });
        },
        
        filterListOfButtons(ev) {
          this.filter_width = "950px"
          if(window.innerWidth > 1400 && window.innerWidth < 1500)
            this.filter_width = "1050px"
          else if(window.innerWidth >= 1500 && window.innerWidth < 1600)
            this.filter_width = "1150px"
          else if(window.innerWidth >= 1600)
            this.filter_width = "1250px"
          this.filterDropdowndata();
          this.client
          this.request_id = '';
          this.crm_ticket_number = '';
          this.request_sub_id = '';
          this.status = null;
          this.request_type = null;
          document.documentElement.style.setProperty('--dialog-ypos', (this.$refs.filterPopupRef.$el.getBoundingClientRect().top + 40).toString() + 'px');
          this.filteWithSubPopup = true;
        },
        filterDropdowndata() {
          Promise.all([
            this.$httpSecured.get(`/api/v1/warehouse/return_initiation/return_creations/filter_data`),
          ])
            .then(([response,]) => {
              const normalized = response.data.statuses.map(s =>
                  s
                    .replace(/[–—]/g, "-")        
                    .replace(/\s*-\s*/g, "-")    
                    .replace(/\s+/g, " ")        
                    .replace(/\b(\w)\s*-\s*(\w)\b/g, "$1-$2") 
                    .replace(/\b(pre)\s+(packaging)/gi, "$1-$2") 
                    .trim()
                    .toLowerCase()
                );

                const uniqueMap = new Map();

                response.data.statuses.forEach((s, i) => {
                  const key = normalized[i];
                  if (!uniqueMap.has(key)) uniqueMap.set(key, s);
                });

                this.status_items = Array.from(uniqueMap.values());
                const removeList = ['Pending Packaging', 'Pending Reverse Pickup', 'Reverse Pickup Closed'];
                  this.status_items = this.status_items.filter(
                    item => !removeList.some(remove => item.includes(remove))
                  );
              this.request_type_items = response.data.request_types;
              this.branch_items = response.data.branches;
            })
            .catch((error) => {
              console.error("Error fetching data:", error);
            });
        },
        closeFilterpopup(){
          this.filteWithSubPopup = false;
          this.crm_ticket_number = '';
          this.request_sub_id = '';
          this.request_id = '';
          this.request_type = null;
          this.status = null;
          this.branch = null;
          this.tag_id = null;
        },
        applyFilterFunc() {
          this.isFiltering = true;
          const params = this.getRequestParams(this.page, this.pageSize);
          const requestBody = {
            status: this.status,
            request_type: this.request_type,
            query: this.request_sub_id,
            client_crm_ticket_no: this.crm_ticket_number,
            branches:this.branch,
            tag_id: this.tag_id,
            page: this.filterPage,
            per_page: params['size']
          };
          
          this.$httpSecured
            .get('/api/v1/warehouse/return_initiation/return_creations?', {params: requestBody})
            .then(response => {
              if (response.data) {
                this.table_data = response.data.return_creation;
                this.totalPages = response.data.meta.total_pages;
                this.totalCount = response.data.meta.total_count
                this.filteWithSubPopup = false;
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
              this.filteWithSubPopup = false;
            });
        },
        deletelot() {
          this.return_id = this.selected.map(lookup_values => lookup_values.id);
          this.deletelotDilog = true;
        },
        deletelotconfirm() {
          this.$httpSecured
            .post("/api/v1/warehouse/return_initiation/return_creations/delete_return_items",{ return_item_ids : this.return_id })
            .then(response => {
              if (response.data) {
                // this.showAlert("success", "item deleted succusfully");
                this.deletelotDilog = false;
                this.successmessage = response.data.message
                this.successpopup = true
              } else {
                this.showAlert("error", "No Data Found");
                this.errormessage = response.data.error
                this.errorpopup = true
              }
            }).catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
            });
        },
        
        formatTimestamp(timestamp) {
          const date = new Date(timestamp);
          const day = date.getDate().toString().padStart(2, '0');
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          const year = date.getFullYear();
          let hour = date.getHours();
          const minute = date.getMinutes();
          const amPM = hour >= 12 ? 'PM' : 'AM';
          hour = hour % 12 || 12;
          const formattedTime = `${hour}:${minute.toString().padStart(2, '0')} ${amPM}`;
          return `${day}/${month}/${year}, ${formattedTime}`;
        },

        linkPopupInReqTracker(item) {
          this.datadetailpopupdisposition = true
          this.return_request_id = item.return_request_id
          this.return_sub_request_id = item.return_sub_request_id;
          this.request_type = item.return_type;
          this.creation_date =  this.formatTimestamp(item.creation_date);;
          this.status = item.status;
          this.$httpSecured
            .get(`/api/v1/warehouse/return_initiation/return_eligibility_validations`)
            .then(response => {
              if (response.data) {
                this.item_details = response.data.return_items
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        scrollToTop() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        },
        afterClickOkLoadData() {
          this.successpopup = false;
          this.successmessage = ''
          this.selected = [];
          this.loadData();
        },
        handlePageChange(value) {
          this.page = value;
          if(this.isFiltering){
            this.filterPage = value;
            this.applyFilterFunc();
            return;
          }
          this.maindata();
        },
        handlePageSizeChange(size) {
        this.pageSize = size;
        this.page = 1;
        this.filterPage = 1;
        if(this.isFiltering){
          this.applyFilterFunc();
          return;
        }
        this.maindata();
        },
        getRequestParams(page, pageSize, filterPage) {
          let params = {};
  
          if (page) {
            params["page"] = page;
          }
          if (pageSize) {
            params["size"] = pageSize;
          }

          if (filterPage) {
            params["filterPage"] = filterPage;
          }

          return params;
        },
        showAlert(alert_type, alert_message) {
          this.alert = true;
          this.alert_type = alert_type;
          this.alert_message = alert_message;
          this.alertTimeOut();
        },
        alertTimeOut() {
          setTimeout(() => {
            this.alert = false;
          }, 3000);
        },
        navigateToFileUpload(condition) {
          this.$store.commit("setLotIds", {
            lotIds: this.headerText,
            inventoryId: condition,
            action:'first_tab'
          });
          this.$store.commit("config/ADD_HEADER", this.headerText);     
          this.$router.push({ name: "LotFileuploadComm" });
        },
        updateStatusDialog(){
          const status_list = this.selected.map(item => item.sub_request_status)
          const unique_status = [...new Set(status_list)]
          if(unique_status.length > 1){
            this.$toast.error("Please select only one status!")
            this.selected = []
            return;
          }
          this.updateStatusPopup = true;
          this.updateStatusGetdata();
        },
        updateStatusGetdata() {
          this.$httpSecured
            .post(`/api/v1/warehouse/return_initiation/return_creations/get_return_creation_statuses`)
            .then(response => {
              if (response.data) {
                this.change_status_items = response.data.statuses.map(status => ({
                  status,
                  disabled: this.isStatusDisabled(status)
                }));
                this.loading = false;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", "Something went wrong from Network" + error);
              this.loading = false;
            });
        },
        isStatusDisabled(status) {
          if (!status) return true;
          return (this.selected[0].sub_request_status == 'In Process – Approved' && status != 'Closed - Reject' && status !='Closed - Approved') || 
          (this.selected[0].sub_request_status == status)
      },     
        submitUpdateStatus(){
          this.number++;
          const returnItemIds = [];
          const returnTicketIds = [];
            this.selected.forEach(item => {
              if (item.item_type === 'return_item') {
                returnItemIds.push(item.id);
              } else if (item.item_type === 'return_item_ticket') {
                returnTicketIds.push(item.id);
              }
            });
            const payload = {
              return_item: returnItemIds,            
              return_item_ticket: returnTicketIds,    
              assign_status: this.change_status.status  
            };
          this.$httpSecured
          .post(`/api/v1/warehouse/return_initiation/return_creations/change_return_creation_item_status`, payload)
          .then(response => {
            if (response.data) {
              this.$toast.success("Successfully updated");
              this.selected = [];
              this.loading = false;
              this.updateStatusPopup = false;
              this.change_status = '';
              this.loadData();
            } else {
              this.number = 0;
              this.loading = false;
              this.showAlert("error", "No Data Found");
            }
          })
          .catch(error => {
            this.number = 0;
            this.showAlert("error", "Something went wrong from Network" + error);
            this.loading = false;
          });
        },
      openEditSerailPopup() {
        if(this.selected[0].sub_request_status === 'Closed - Reject' || this.selected[0].sub_request_status === 'Closed - Approved'){
          this.snackbar = {
               color: "error",
               icon: "mdi-alert-circle",
               mode: "multi-line",
               position: "bottom",
               timeout: 3000,
               title: 'Success',
               text: "Serial No can't be edited for subrequest ID's with closed status",
               visible: true
             };
        }else{
          this.editSerialPopup = true;
          this.serial_number_file_name = '';
          this.serial_number_1 = this.selected[0].serial_number;
          this.serial_number_2 = this.selected[0].split_serial_number;
          this.serial_number_file = null;
        }
          
        },
     handleImageUpload(file) {
        if (!file) return;
        const fileType = file.type;
        if (fileType !== 'application/pdf') {
          this.fileError = true;
          this.fileErrorMessage = 'Only PDF files are allowed.';
          this.serial_number_file = null;
        } else {
          this.fileError = false;
          this.fileErrorMessage = '';
          this.serial_number_file_name = file.name; 
          this.serial_number_file = file;  
        }
              
      },
        submitEditSerialNo() {
          const formData = new FormData();
          const return_id = this.selected.map(return_items => return_items.id);
          formData.append('return_item[id]', return_id)
          formData.append('return_item[serial_number]', this.serial_number_1)
          formData.append('return_item[split_serial_number]', this.serial_number_2)
          formData.append('return_item[serial_number_approval_attachment]', this.serial_number_file)
          this.$httpSecured
            .post(`api/v1/warehouse/return_initiation/return_creations/update_serial_number`,formData)
            .then(response => {
              if (response.data) {
                 this.editSerialPopup = false;
                 this.selected = [];
                 this.successpopup = true;
                 this.successmessage = response.data.message;
              } else {
                this.loading = false;
                this.showAlert("error", "No Data Found");
              }
            })
            .catch(error => {
              this.showAlert("error", error.response.data.error);
            });
        },
      toHeaderName(key) {
          return key
            .replace(/_/g, " ")                  // snake_case → snake case
            .replace(/([A-Z])/g, " $1")          // camelCase → camel Case
            .replace(/\s+/g, " ")                // clean spaces
            .trim()
            .replace(/\b\w/g, c => c.toUpperCase()); // capitalize
        },
      downloadFlatData() {
        const data = this.selected.length > 0 ? this.selected : this.table_data;

        if (!data || data.length === 0) return;

        const allKeys = Object.keys(data[0]);

        const filteredKeys = allKeys.filter(key => {
          const val = data[0][key];
          return !(Array.isArray(val) || (val !== null && typeof val === "object"));
        });

        const headerTexts = filteredKeys.map(key => this.toHeaderName(key));
        const flatData = data.map(row => {
          const flatRow = {};
          filteredKeys.forEach(key => {
            let val = row[key];
            if (Array.isArray(val) || (val !== null && typeof val === "object")) {
              val = "";
            }
            flatRow[key] = val ?? "";
          });
          return flatRow;
        });

        const csvRows = [];
        csvRows.push(headerTexts.join(",")); // header row

        flatData.forEach(row => {
          const values = filteredKeys.map(key => `"${row[key] ?? ""}"`);
          csvRows.push(values.join(","));
        });

        const csv = csvRows.join("\n");
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "return_creation.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },

      downloadFile() { 
        this.number++;
        const params = {
          ids: this.selected.map(selectedItem => selectedItem.id)
        }
        this.$httpSecured
          .get("/api/v1/warehouse/return_initiation/return_creations/download_approval_doc_file", { params: params })
          .then(response => {
              if (response.data) {
             const url = response.data.url;
              const link = document.createElement('a');
              link.href = url;
              link.download = '';
              document.body.appendChild(link);
              link.click();
              this.snackbar = {
                      color: "success",
                      icon: "mdi-check-circle",
                      mode: "multi-line",
                      position: "top",
                      timeout: 3000,
                      title: "Success",
                      text: "(CSV File) Downloaded Successfully",
                      visible: true
                    };
                  this.selected = [];
                  this.number = 0;
              } else {
                  this.loading = false;
                  this.showAlert("error", "No Data Found");
                  this.number = 0;
              }
          })
        .catch(error => {
          this.showAlert("error", "Something went wrong from Network" + error);
          this.loading = false;
          this.number = 0;
        });
      },
      isActionDisabled(item) {
        if (this.headerText === 'Return Creation' && item === "Download") {
          return false;
          }
        if(this.headerText === 'Request & Tickets' && item === 'Download') {
            return !this.selected.length > 0;
          }

        if (item === "Upload Tickets") {
            return false;
          }
        if (item === "Create Request") {
            return false;
          }
        if (item === "Edit Serial No") {
            return !(this.selected.length === 1 && this.currentUser.roles[0] === "admin");
          }
        if (item === "Assign SP/ST") {
            return !(this.selected.length > 0 && this.undeliveredSelected.length === 0 && this.closedStatus.length === 0);
          }
        if (item === "Update Status") {
            if (!this.$isWhirlpoolClient()) return true;

            return (
              this.selected.length === 0 ||
              this.selected.some(item =>
                item.sub_request_status === "Closed - Reject" ||
                item.sub_request_status === "Closed - Approved"
              )
            );
          }
          if (item === "Offline Upload Template") {
            return false;
          }
          return false;
      },
      updateAction(item) {
        if(this.headerText === 'Return Creation' && item == 'Download'){
            this.downloadFlatData();
        }else if(this.headerText === 'Request & Tickets' && item == 'Download'){
            this.downloadFile();
        }else if(this.headerText === 'Request & Tickets' && item == 'Upload'){
            this.navigateToFileUpload("upload");
        }else if(item == 'Edit Serial No'){
            this.openEditSerailPopup();
        }else if(item == 'Update Status'){
            this.updateStatusDialog();
        }else if(item == 'Upload Tickets'){
            this.navigateToFileUpload("upload_tickets");
        }else if(item == 'Create Request'){
            this.$router.push('/api/v2/return-creation/return-claim-request');      
        }else if(item == 'Assign SP/ST'){
            this.invoiceItemDataPopup();
        }else if(item == 'Offline Upload Template'){
            this.navigateToFileUpload("offline_upload_template");
        }
      }
    },
  }
  </script>
  <style scoped>
  .v-dialog>.v-card>:has(.v-card__title){
    overflow-wrap: break-word !important;
  }
  .custom-control_outlined .v-expansion-panel:before {
      box-shadow: none;
    }
    /* .v-btn .v-btn__content .v-icon {
      color:white !important;
    } */
    .img-rad-size {
      width: 186px;
      height: 184px;
      border-radius: 8px;
    }
    .custom-control_outlined button {
      min-height: 52px;
      border-width: 1px;
      border-radius: 4px;
      border-color: rgba(0,0,0,.42);
      border-style: solid;
    }
    .custom-control_outlined button:focus {
      outline: none;
    }
    .v-dialog:has(.filter-insurance){
    justify-content: right;
    align-items: baseline;
    top: var(--dialog-ypos);
  }
  .my-autocomplete {
      background-color: #1976d2;
      color: white;
    }
  /* .theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
    background-color: #1867c0 !important;
    color: #fff !important;
    margin-bottom: -35px !important;
  } */
  .field > .v-input__control > .v-input__slot {
    background-color: #1976d2 !important;
    min-height: 36px;
  } 
  .field > .v-input__control > .v-input__slot .v-label {
    color: #fff !important;
  }
  .field > .v-input__control > .v-input__slot input{
    color: #fff;
  }
  .field > .v-input__control > .v-input__slot .v-input__append-inner .v-icon {
    color: #fff !important;
  }
  .field > .v-input__control > .v-input__slot > .v-input__icon .mdi-menu-down::before{
    color: #fff !important;
  }
  .v-data-table {
    height: calc(var(--vh, 1vh) * 100 - 265px) !important;
  }
  .v-data-table.approval-history {
    height: calc(var(--vh, 1vh) * 100 - 690px) !important;
  }
  .filter_ui{
    margin-left: 32px !important;
    margin-top: 12px !important;
  }

  </style>